import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessagesService } from '@core/_services/messages.service';

@Component({
    selector: 'filterdocs',
    templateUrl: 'filterdocs.component.html',
    styleUrls: ['filterdocs.component.scss'],
})
export class FilterDocsComponent {
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    @Output()
    public onFilter: EventEmitter<any> = new EventEmitter();

    public searchText: string;

    constructor( protected _messageService: MessagesService,
        private translate: TranslateService) {
        this.searchText = '';
    }

    public onClickSearch() {
        if (this.searchText.trim() === '') {
            this._messageService.addErrorNoStick(this.translate.instant('Cnt_Req'));
            return;
        } 
        this.onFilter.emit({
            searchText: this.searchText,
        });
    }

    public close() {
        this.onClose.emit();
    }

    public closeSearch() {
        this.close();
    }
}
